import PageTitle from "../../../layouts/PageTitle";
import React, { useState, Fragment, useEffect } from "react";
import './General.css'
import {
   UpdateSiteLiveStatus
} from './Requests';
import { ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  notifyError,
  notifySuccess
} from '../Response/ResposeHandler'
const General = (props) => {
    const [isLive, setIsLive] = useState(props.site.isLive);
    const [liveError, setLiveError] = useState()
    
    function LiveToggleHandler (e) {
        UpdateSiteLiveStatus(e.target.checked).then((res) => {
            console.log(e.target.checked)
            if ((res.status === 200) && e.target.checked === true)
            {
                notifySuccess("Site is now online")
                setIsLive(e.target.checked)
            }
            if ((res.status === 200) && e.target.checked === false)
            {
                notifySuccess("Site is now offline")
                setIsLive(e.target.checked)
            }
            setLiveError()
        }).catch((error) => {
            console.log(error.response.data)
            if ((error.response.data === "Site settings are missing"))
            {
                notifyError("Unable to publish site")
                setLiveError("Please make sure that you have provided a site title under the details tab")
                setIsLive(false)
            }
        }).finally(()=> {
        })
        setIsLive(e.target.checked)
    }
  
  return (
  <div style={{marginLeft:"auto", marginRight:"auto"}}>
    <ToastContainer />

    <div className="general-container mt-5">
        <div className="general-toggle-card">
            {liveError !== undefined
            ?
            <div className="error-bar">
                {liveError}
            </div>
            :
            <></>
            }


            <div className="toggle-live-container">
                <span style={{marginLeft:"2rem"}} className='label-title'>Live</span>
                <div style={{marginRight:"2rem"}} className="live-switch-wrapper">
                    <input
                        className="toggle-switch"
                        type="checkbox"
                        checked={isLive}
                        id="logon"
                        onChange={(e) => {LiveToggleHandler(e)}}
                    />
                    <label htmlFor='logon' className="switch-label"/>
                </div>
            </div>
        </div>
        </div>
        <div className="general-container">
            <div className="general-card">
                <div className="link-booking-block">
                    <p>Booking Portal</p>
                    {/* <a href="https://www.google.com" target="_blank" rel="noopener noreferrer"> */}
                        <a target="_blank" style={{textDecoration: "underline"}} href={"make-a-booking?id=" + props.shopId}>{process.env.REACT_APP_CLIENT_BASE_URL}make-a-booking?id={props.shopId}</a>
                    {/* </a> */}
                </div>
            </div>
            <div className="general-card">
                <div className="link-site-block">
                    <p>Mini Site</p>
                        <a target="_blank" style={{textDecoration: "underline"}} href={"client-site?site=" + props.shopId}>{process.env.REACT_APP_CLIENT_BASE_URL}client-site?site={props.shopId}</a>
                </div>
            </div>
        </div>
    </div>
    );
}

export default General;